module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-Medium-50ae55810d35f989b0459189f61990c4.ttf";